import { uniqueId } from 'lodash'

export const addError = 'addError'
export const solveError = 'solveError'
export const solveAllErrors = 'solveAllErrors'

export const fetchInitialDataRequest = 'fetchInitialDataRequest'
export const fetchInitialDataResponse = 'fetchInitialDataResponse'

export default {
  [addError] (state, error) {
    // No need the same error multiple times (e.g. login credentials incorrect)
    if (
      state.errors.find(
        ({ message, code }) => message === error.message && code === error.code
      )
    ) {
      return
    }
    state.errors = [
      ...state.errors,
      { timestamp: Date.now(), id: uniqueId(), ...error }
    ]
  },
  [solveError] (state, id) {
    state.errors = state.errors.filter(error => error.id !== id)
  },
  [solveAllErrors] (state, id) {
    state.errors = []
  },
  [fetchInitialDataRequest] (state) {
    state.hasInitialData = false
  },
  [fetchInitialDataResponse] (state) {
    state.hasInitialData = true
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js